import script from "./TextProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./TextProjects.vue?vue&type=script&setup=true&lang=js"

import "./TextProjects.vue?vue&type=style&index=0&id=01c44a6e&lang=css"

const __exports__ = script;

export default __exports__